import './App.css';
import Row from './Components/Row';
import requests from './requests';
import Banner from './Components/Banner';
import Nav from './Components/Nav';

function App() {

  return (
    <div className="App">
        <Nav />
        <Banner/>
        <Row
          title="Netflix Originals" 
          fetchUrl={requests.fetchNetflixOriginals}
          isLargeRow
        />
        <Row title="Trending Now" fetchUrl={requests.fetchTrending}/>
        <Row title="Top Rated" fetchUrl={requests.fetchTopRated}/>
        <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}/>
        <Row title="Comedy Movies " fetchUrl={requests.fetchComedyMovies}/>
        <Row title="Horror Movies " fetchUrl={requests.fetchHorrorMovies}/>
        <Row title="Romance Movies " fetchUrl={requests.fetchRomanceMovies}/>
        <Row title="Documentaries " fetchUrl={requests.fetchDocumentariesMovies}/>
    </div>
  );
}

export default App;
